// @ts-nocheck
import React, { FC, useState, useEffect } from "react"
import { RouteComponentProps } from "@reach/router"
import _ from "lodash"
// Data
import { local } from 'data/lib/local-json'
import propertyService from "data/property"
// Components
import ValuationScenarioForm from "components/property/valuation-settings/valuation-scenario-form"
// Styles
import { ValuationContainer_s, ValuationScenarioDropdowns_s, ValuationLabels_s, ValuationScenarios_s } from "components/property/valuation-settings/valuation-settings-styles"
import { Dropdown_s } from "styles/input-styles"

const ValuationSettings: FC<RouteComponentProps> = () => {
  const [property, setProperty]                 = useState<object|null>(null)
  const [data, setData]                         = useState<object[]|null>(null)
  const [valuationPeriods, setValuationPeriods] = useState<number>(1)
  const [defaultScenario, setDefaultScenario]   = useState<number|null>(null)
  const [once, setOnce]                         = useState<boolean>(false)
  const propertyId    = local('property')
  const isCommercial  = property?.['type'] === 'Commercial'
  const isMultifamily = property?.['type'] === 'Multifamily'

  useEffect(() => {
    if (property){
      let updatedProperty = _.cloneDeep(property);
      if (valuationPeriods < updatedProperty['valuationdetail'].length) updatedProperty['valuationdetail'] = updatedProperty['valuationdetail'].slice(0, valuationPeriods);
      else {
        const currentRecords = updatedProperty['valuationdetail'].length;
        let addtlRecords = valuationPeriods - currentRecords;
        for (let i in Array.from(Array(addtlRecords))){
          let record = _.cloneDeep(updatedProperty['valuationdetail'][currentRecords - 1])
          let num    = currentRecords + parseInt(i) + 1
          record['defaultScenario'] = false
          record['valuationPeriod'] = num
          record['valuationDescription'] = `Valuation Scenario #${num}`
          updatedProperty['valuationdetail'].push(record)
        }
      }
      let previous = _.find(updatedProperty.valuationdetail, {defaultScenario: true})
      if (!previous) updatedProperty['valuationdetail'][0].defaultScenario = true
      propertyService.patch(updatedProperty);
    }
  }, [valuationPeriods])

  useEffect(() => {
    if (property && defaultScenario){
      let updatedProperty = _.cloneDeep(property);
      let previous = _.find(updatedProperty.valuationdetail, {defaultScenario: true})
      let next = _.find(updatedProperty.valuationdetail, {valuationPeriod: defaultScenario})
      previous['defaultScenario'] = false;
      next['defaultScenario'] = true
      propertyService.patch(updatedProperty);
    }
  }, [defaultScenario])

  useEffect(() => {
    const propertySubscription = propertyService.stream().subscribe((data) => {
      if (data.value.length > 0){
        const currentProperty = _.find(data.value, {propertyid: data.current});
        let valuationData = currentProperty['valuationdetail']
        if (currentProperty['type']=== 'Multifamily'){
          valuationData.map(data => delete data['vacancyLossAdjustment'])
        }
        setProperty(currentProperty)
        setData(valuationData)
        setValuationPeriods(valuationData.length)
        setDefaultScenario(_.find(valuationData, {defaultScenario: true}).valuationPeriod)
      }
    })

    propertyService.fetchProperty(propertyId)


    return function cleanup() {
      propertySubscription.unsubscribe()
    }
  }, [propertyId])

  useEffect(() => {
    const firstInput = document.getElementById('valuationPeriodsInput');
    const input = firstInput?.getElementsByTagName('INPUT')[0]
    if (!once && input){
      input?.focus()
      setOnce(true)
    }
  });

  let valuationLabels = [
    "Scenario Description",
    "Valuation Type",
    "Valuation Date Type",
    "Valuation Date",
    "Specified Price",
    "Going-In Capitalization Rate",
    "Valuation Term (Years)",
    "Discount Rate",
    "Discount Rate Increment",
    "Terminal Capitalization Rate",
    "Capitalization Rate Increment",
    "Cost of Sales %",
    "IRR/NPV Discounting",
    "Reversion Cap Year",
    ...(isCommercial || isMultifamily ? ["Abatement Gross-up"] : []),
    ...(isCommercial ? ["Stabilize Sale Vacancy Loss"] : []),
    "Capital Items Adjustment",
    "$ Adjustment Amount",
    "Valuation Amount",
    "Valuation Per Area"
  ]

  const persist = (i, field, val) => {
    const updatedData = _.cloneDeep(data);
    const updatedProperty = _.cloneDeep(property);
    updatedData[i - 1][field] = val

    if (field === 'valuationType' && val === "DCF"){
      delete updatedData[i - 1]['valuationDate']
      delete updatedData[i - 1]['specifiedPrice']
      delete updatedData[i - 1]['goingInCapitalizationRate']
      updatedData[i - 1]['irrNpvDiscounting'] = 'Annual'
      updatedData[i - 1]['salesNoiCapYear'] = 'Sale Year + 1'
    }
    if (field === "valuationType" && val === "Specified Price"){
      delete updatedData[i - 1]['valuationDate']
      delete updatedData[i - 1]['discountRate']
      delete updatedData[i - 1]['goingInCapitalizationRate']
      updatedData[i - 1]['irrNpvDiscounting'] = 'Annual'
      updatedData[i - 1]['salesNoiCapYear'] = 'Sale Year + 1'
    }
    if (field === "valuationType" && val === "Direct Cap"){
      delete updatedData[i - 1]['valuationDate']
      delete updatedData[i - 1]['specifiedPrice']
      delete updatedData[i - 1]['term']
      delete updatedData[i - 1]['discountRate']
      delete updatedData[i - 1]['discountRateIncrement']
      delete updatedData[i - 1]['terminalCap']
      delete updatedData[i - 1]['irrNpvDiscounting']
      delete updatedData[i - 1]['salesNoiCapYear']
    }

    if (field === "valuationDateType" && val !== "Specified Date") delete updatedProperty.valuationdetail[i - 1]['valuationDate']
    updatedProperty['valuationdetail'] = updatedData
    propertyService.patch(updatedProperty)
    setData(updatedData)
    setProperty(updatedProperty)
  }

  return property && data && <div>
    <ValuationScenarioDropdowns_s>
      <div>
        <label htmlFor="valuationPeriodsInput"># of Valuation Scenarios: </label>
        <Dropdown_s
          id="valuationPeriodsInput"
          onChange={(e) => setValuationPeriods(e.value)}
          optionLabel="text"
          options={[1, 2, 3, 4, 5].map(val => { return { 'text': val, 'value': val}})}
          value={valuationPeriods}
        />
      </div>
      <div>
        <label htmlFor="defaultScenarioInput">Default Scenario #: </label>
        <Dropdown_s
          id="valuationPeriodsInput"
          onChange={(e) => setDefaultScenario(e.value)}
          optionLabel="text"
          options={data.map(v => { return { 'text': v['valuationPeriod'], 'value': v['valuationPeriod'] } })}
          value={defaultScenario}
        />
      </div>
    </ValuationScenarioDropdowns_s>
    <ValuationContainer_s>
      <ValuationLabels_s>
        {valuationLabels.map(label => <label>{label}</label>)}
      </ValuationLabels_s>
      <ValuationScenarios_s>
        { data.map((valuationScenario, i) => { return <ValuationScenarioForm valuationScenario={valuationScenario} i={i+1} persist={persist} property={property} /> })}
      </ValuationScenarios_s>
    </ValuationContainer_s>
  </div>
}

export default ValuationSettings
